import axios from "axios";
import { baseUrl } from "./config";
import qs from "qs";
import { catchCode, catchError } from '../common/js/util'

const instance = axios.create({
  baseURL: baseUrl,
  timeout: 20000,
  withCredentials: true
  // headers: {'X-Requested-With': 'XMLHttpRequest'}
});

instance.interceptors.request.use(
  config => {
    config.data = qs.stringify(config.data);
    return config;
  },
  err => {
    console.log(err);
  }
);

instance.interceptors.response.use(response => {
  if (response.data.statusCode === 200) {
    return response.data.data;
  } else {
    catchCode(response.data.statusCode, response.data.msg)
    return 'isError'
  }
}, catchError);

export default instance;
